// extracted by mini-css-extract-plugin
module.exports = {"headerLeftSide":"_2WsON","headerTop":"_2ed8r","linkWrapper":"_1JD37","link":"_26zra","name":"_2Gw3W","bulletSeparator":"_2J9PH","timeAgo":"lGqJA","badge":"_3Um86"};